<template>
  <Container
    class="mx-auto mt-10 gap-5 md:mt-15 md:gap-7.5 xl:mt-17.5! xl:gap-10 2xl:mt-20! 2xl:gap-11.5"
  >
    <SectionTitle
      :title="sectionData.title"
      :link="sectionData.url"
      :target="sectionData.target"
    />
    <CardSlider :slides="exhibitionData" />
  </Container>
</template>

<script setup lang="ts">
import type { AppEvent, HomepageSection } from '~/types'

interface Props {
  sectionData: HomepageSection<AppEvent>
}

const props = defineProps<Props>()

const exhibitionData = computed(() => props.sectionData?.items)
</script>
